module.exports = __webpack_public_path__ + "media/images/profile-01-p-500-133cfd452914aa934c22cf0c893a503c.png";